import { createReducer } from "@ngrx/store";
import { UserState } from "./user.models";
import * as UserActions from "./user.actions";
import { on } from "@ngrx/store";

export const initialState : UserState = {
  data : null,
  allData: null,
  error: null,
  message: null,
  success: false,
  validationError: []
}

export const userReducer = createReducer(
  initialState,

  on(UserActions.UserClearState, () => ({
    ...initialState,
  })),

  on(UserActions.UserProfilePatched, (state, payload) => ({
    ...state,
    data: state.data?.id === payload.user.id ? payload.user : state.data,
    allData: state.allData?.map((user) => user.id === payload.user.id ? payload.user : user) ?? state.allData,
  })),

  on(UserActions.UserGetSuccess, (state, payload) => ({
    ...state,
    data: payload.user,
    error: null,
    message: "User details fetched successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserGetFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserGetAllSuccess, (state, payload) => ({
    ...state,
    allData: payload.users,
    error: null,
    message: "All users fetched successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserGetAllFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserCreateSuccess, (state, payload) => ({
    ...state,
    allData: state.allData ? [payload.user, ...state.allData] : [payload.user],
    error: null,
    message: "User created successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserCreateFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserManageUpdateSuccess, (state, payload) => ({
    ...state,
    data: state.data?.id === payload.user.id ? payload.user : state.data,
    allData: state.allData?.map((user) => user.id === payload.user.id ? payload.user : user) ?? state.allData,
    error: null,
    message: "User updated successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserManageUpdateFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserManageStatusSuccess, (state, payload) => ({
    ...state,
    data: state.data?.id === payload.user.id ? payload.user : state.data,
    allData: state.allData?.map((user) => user.id === payload.user.id ? payload.user : user) ?? state.allData,
    error: null,
    message: "User status updated successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserManageStatusFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserManageDeleteSuccess, (state, { userId }) => ({
    ...state,
    data: state.data?.id === userId ? null : state.data,
    allData: state.allData?.filter((user) => user.id !== userId) ?? state.allData,
    error: null,
    message: "User deleted successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserManageDeleteFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserUpdateSuccess, (state, payload) => ({
    ...state,
    data: payload.user,
    allData: state.allData?.map((user) => user.id === payload.user.id ? payload.user : user) ?? state.allData,
    error: null,
    message: "User profile updated successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserUpdateFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserSetAvailabilityStatusSuccess, (state, payload) => ({
    ...state,
    data: payload.user,
    allData: state.allData?.map((user) => user.id === payload.user.id ? payload.user : user) ?? state.allData,
    error: null,
    message: 'Availability status updated successfully',
    success: true,
    validationError: []
  })),

  on(UserActions.UserSetAvailabilityStatusFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserRemoveProfilePhotoSuccess, (state, payload) => ({
    ...state,
    data: payload.user,
    allData: state.allData?.map((user) => user.id === payload.user.id ? payload.user : user) ?? state.allData,
    error: null,
    message: "Profile photo removed successfully",
    success: true,
    validationError: []
  })),

  on(UserActions.UserRemoveProfilePhotoFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserValidationError, (state, { validationErrors }) => ({
    ...state,
    validationError: validationErrors,
    error: null,
    message: null,
    success: false
  })),

  on(UserActions.UserClearValidationError, (state) => ({
    ...state,
    validationError: [],
    error: null,
    message: null,
    success: false
  }))
);
